import { createContext, useContext } from 'react';

/** The indexes of rows to render */
type Virtualized = number[];

const context = createContext<Virtualized>([]);

export const VirtualizedProvider = context.Provider;
export const useVirtualized = () => useContext(context);
